module.exports = __webpack_public_path__ + "img/医康养护.ad075c83.png";